import { createApi, ApiError } from "@mnp/shared";

const API_BASE = import.meta.env.VITE_API_BASE || "";

function getInitData(): string {
  const tg = (window as any).Telegram?.WebApp;
  return tg?.initData || "";
}

// Mini App auth is carried via `Authorization: tma <initData>` — мы не
// читаем/пишем cookies, поэтому `credentials: include` не нужен и только
// расширил бы CORS-поверхность. Admin-панель отдельно использует cookie-сессию.
export const api = createApi({
  baseUrl: `${API_BASE}/api/v1`,
  getAuthHeaders: () => ({ authorization: `tma ${getInitData()}` }),
});

export { ApiError };
